import { jsPDF } from 'jspdf';
import autoTable from 'jspdf-autotable';
import html2canvas from 'html2canvas';
import { fontFaces } from '../../../../assets/fonts/fonts';
import Logo from "../../../../styles/img/CompliNYC-Logo.png";

/**
 * Generates a Building Compliance PDF report
 * @param {Object} clientData - Client data object
 * @param {Object} buildingData - Building data object
 * @returns {Promise<Blob>} - PDF blob
 */
export const generateBuildingCompliancePDF = async (pdfData,statusCount) => {
  if (!pdfData) {
    throw new Error("Missing required data for PDF generation");
  }
  const currentYear = new Date().getFullYear();
  // Create PDF document
  const doc = new jsPDF();
  
  // Create building overview page using HTML
  await createBuildingOverviewPageFromHTML(doc, pdfData,statusCount);
  
  // Add visual inspection page
  doc.addPage();
  await createVisualInspectionPageFromHTML(
    doc,
    pdfData.filter(
      (unit) =>
        unit.compliance.status == "in_process" &&
        unit.compliance.child_under_6_required == true
    ),
    {
      title: "VISUAL INSPECTION ",
      tableTitle: "Visual Inspection",
      subtitle:
        `We found ${statusCount.inspection_needed} units requiring lead paint inspection for mailing year ${currentYear} in your portfolio.`,
    },
    {
      notRequired: pdfData.filter(
        (unit) =>
          unit.compliance.status !== "pending" &&
          unit.compliance.child_under_6_required !== true
      ).length,
      inspection: statusCount.inspection_needed,
    }
  );

  const windowGuardInspection = pdfData.filter(
    (unit) =>
      unit.compliance.status == "in_process" &&
      (unit.compliance?.window_guards_installed == false ||
        unit.compliance?.window_guards_installed_anyway == true)
  ).length;
  const windowGuardRepair = pdfData.filter(
    (unit) =>
      unit.compliance.status == "in_process" &&
      (unit.compliance?.window_guards_need_repair == true ||
        unit.compliance?.window_guards_need_repair_existing == true)
  ).length;

  doc.addPage();
  await createVisualInspectionPageFromHTML(
    doc,
    pdfData.filter(
      (unit) =>
        unit.compliance.status == "in_process" &&
        (unit.compliance?.window_guards_installed == false ||
          unit.compliance?.window_guards_installed_anyway == true ||
          unit.compliance?.window_guards_need_repair == true ||
          unit.compliance?.window_guards_need_repair_existing == true)
    ),
    {
      title: "WINDOW GUARD ACTION  ",
      tableTitle: "Window Guards",
      subtitle:
        `We found ${windowGuardInspection + windowGuardRepair} units requiring window guard action for mailing year ${currentYear} in your portfolio.`,
      isRepairs: true,
    },
    {
      notRequired: pdfData.filter(
        (unit) =>
          unit.compliance.status !== "pending" &&
          (unit.compliance?.window_guards_installed !== false &&
            unit.compliance?.window_guards_installed_anyway !== true &&
            unit.compliance?.window_guards_need_repair !== true &&
            unit.compliance?.window_guards_need_repair_existing !== true)
      ).length,
      inspection: windowGuardInspection,
      repair: windowGuardRepair,
    }
  );

    doc.addPage();
    await createVisualInspectionPageFromHTML(
      doc,
      pdfData.filter(
        (unit) =>
          (unit.compliance?.stove_knob_covers == true ||
            unit.compliance?.permanent_stove_safety_knobs == true) &&
          unit.compliance.status == "in_process"
      ),
      {
        title: "KNOB COVER INSTALLATION ",
        tableTitle: "Knob Cover Installation",
        subtitle:
          `We found ${statusCount.knob_covers_required} units requiring knob cover installation for mailing year ${currentYear} in your portfolio.`,
      },
      {
        notRequired: pdfData.filter(
          (unit) =>
            unit.compliance?.stove_knob_covers !== true &&
            unit.compliance?.permanent_stove_safety_knobs !== true &&
            unit.compliance.status !== "pending"
        ).length,
        inspection: statusCount.knob_covers_required,
      }
    );

    doc.addPage();
    await createVisualInspectionPageFromHTML(
      doc,
      pdfData.filter(
        (unit) =>
          unit.compliance?.fire_safety_required == true &&
          unit.compliance.status == "in_process"
      ),
      {
        title: "FIRE SAFETY NOTICE",
        tableTitle: "Fire Safety Notice",
        subtitle:
          `We found ${statusCount.fire_safety_required_count} units requiring fire safety notice for mailing year ${currentYear} in your portfolio.`,
        fireSafety: true,
      },
      {
        notRequired: pdfData.filter(
          (unit) =>
            unit.compliance?.fire_safety_required !== true &&
            unit.compliance.status !== "pending"
        ).length,
        inspection: statusCount.fire_safety_required_count,
      }
    );

    
  
  // Add a new page for detailed data
  // doc.addPage();
  
  // // Add title
  // doc.setFontSize(18);
  // doc.setTextColor(33, 33, 33);
  // doc.text('Building Compliance Report - Annual Notices', 105, 20, { align: 'center' });
  
  // // Add client and building info
  // doc.setFontSize(12);
  // doc.text(`Client: ${clientData.name}`, 20, 35);
  // doc.text(`Building: ${buildingData.name}`, 20, 45);
  // doc.text(`Date: ${new Date().toLocaleDateString()}`, 20, 55);
  
  // // Add description
  // doc.setFontSize(11);
  // doc.text('This report provides a unit-level breakdown of required annual safety actions:', 20, 70);
  
  // // Create table
  // const tableColumn = ["Unit", "Visual Inspection", "Knob Covers", "Window Guards", "Repairs"];
  // const tableRows = buildingData.units.map(unit => [
  //   unit.unit,
  //   unit.visualInspection,
  //   unit.knobCovers,
  //   unit.windowGuards,
  //   unit.repairs
  // ]);
  
  // // Generate the table
  // autoTable(doc, {
  //   head: [tableColumn],
  //   body: tableRows,
  //   startY: 80,
  //   styles: { fontSize: 10, cellPadding: 3 },
  //   headStyles: { fillColor: [22, 160, 133], textColor: [255, 255, 255] },
  //   alternateRowStyles: { fillColor: [242, 242, 242] },
  //   columnStyles: {
  //     0: { cellWidth: 25 },
  //     1: { cellWidth: 40 },
  //     2: { cellWidth: 40 },
  //     3: { cellWidth: 40 },
  //     4: { cellWidth: 40 }
  //   }
  // });
  
  // // Add compliance summary
  // const finalY = doc.lastAutoTable.finalY || 120;
  // doc.text('Compliance Summary:', 20, finalY + 20);
  
  // // Calculate compliance stats
  // const totalUnits = buildingData.units.length;
  // const completeVisual = buildingData.units.filter(u => u.visualInspection === 'Complete').length;
  // const requiredKnobs = buildingData.units.filter(u => u.knobCovers === 'Required').length;
  // const completeWindows = buildingData.units.filter(u => u.windowGuards === 'Complete').length;
  // const requiredRepairs = buildingData.units.filter(u => u.repairs === 'Required').length;
  
  // // Add stats
  // doc.text(`• Visual Inspections: ${completeVisual}/${totalUnits} complete (${Math.round(completeVisual/totalUnits*100)}%)`, 25, finalY + 30);
  // doc.text(`• Knob Covers Required: ${requiredKnobs}/${totalUnits} units (${Math.round(requiredKnobs/totalUnits*100)}%)`, 25, finalY + 40);
  // doc.text(`• Window Guards Complete: ${completeWindows}/${totalUnits} units (${Math.round(completeWindows/totalUnits*100)}%)`, 25, finalY + 50);
  // doc.text(`• Repairs Required: ${requiredRepairs}/${totalUnits} units (${Math.round(requiredRepairs/totalUnits*100)}%)`, 25, finalY + 60);
  
  // // Add footer
  // doc.setFontSize(10);
  // doc.text('This report was generated automatically. For questions, contact support@complinyc.com', 105, 280, { align: 'center' });
  
  return doc;
};

/**
 * Creates a visual inspection page from HTML
 * @param {jsPDF} doc - The PDF document
 * @param {Object} buildingData - Building data
 */
const createVisualInspectionPageFromHTML = async (
  doc,
  buildingData,
  { title, subtitle, isRepairs, tableTitle, fireSafety=false },
  { notRequired, inspection, repair }
) => {
  // Define how many rows per page
  const ROWS_PER_PAGE = 10;
  
  // Calculate total pages needed
  const totalPages = Math.ceil(buildingData.length / ROWS_PER_PAGE);
  
  // Process each page
  for (let pageNum = 0; pageNum < totalPages; pageNum++) {
    // If not the first page, add a new page
    if (pageNum > 0) {
      doc.addPage();
    }
    
    // Slice the data for current page
    const startIndex = pageNum * ROWS_PER_PAGE;
    const endIndex = Math.min(startIndex + ROWS_PER_PAGE, buildingData.length);
    const currentPageData = buildingData.slice(startIndex, endIndex);
    
    // Create a temporary div to hold our HTML
    const tempDiv = document.createElement("div");
    tempDiv.style.position = "absolute";
    tempDiv.style.left = "-9999px";
    tempDiv.style.top = "-9999px";
    tempDiv.style.width = "794px"; // A4 width in pixels at 96 DPI
    
    // Map current page data to inspection units
    const inspectionUnits = currentPageData.map((unit) => ({
      unit: unit.unit_number,
      address: unit.building_address,
    }));
    
    // Create HTML content for visual inspection page
    tempDiv.innerHTML = `
      <style>
        ${fontFaces}
        
        * {
          box-sizing: border-box;
          margin: 0;
          padding: 0;
        }
        
        table {
          border-collapse: collapse;
          width: 100%;
          border: 1px solid #E5E7EC;
          border-radius: 8px;
          box-shadow: 0px 12px 23px 0px #3E49540A;
        }
        
        th, td {
          padding: 12px;
          text-align: left;
        }

        thead {
          background-color: #F5F5F9;
          border-radius: 8px 8px 0 0;
        }
        
        th {
          color: #1B3E61;
          font-family: "segoe_uisemibold";
          font-size: 14px;  
        }
        
        tr:nth-child(even) {
          background-color: #F9FAFB;
        }
        
        .inspection-badge {
          background-color: #FF0000;
          color: white;
          padding: 6px 12px;
          border-radius: 4px;
          display: inline-block;
          font-size: 12px;
          text-align: center;
        }
        
        .unit-badge {
          background-color: #16304F;
          color: white;
          padding: 6px 12px;
          border-radius: 4px;
          display: inline-block;
          font-size: 12px;
          text-align: center;
          min-width: 36px;
        }
      </style>
      <div style="width: 794px; height: 1123px; padding: 40px; font-family: 'Segoe UI Regular', sans-serif; position: relative; box-sizing: border-box; background-color: white;">
      <div style="display: flex; justify-content: center; align-items: center; margin-bottom: 30px;">
      <img src="${Logo}" style="width: 180px;">
      </div>
        <!-- Title -->
        <div style="text-align: center; margin-bottom: 30px;">
          <h1 style="color: #16304F; font-size: 32px; font-weight: bold; margin: 0; font-family: 'Segoe UI Bold'; text-transform: uppercase;">${title}</h1>
        </div>
        
        <!-- Horizontal line -->
        <div style="width: 100%; height: 1px; background-color: #EEEEEE; margin: 20px 0;"></div>
        
        <!-- Subtitle -->
        <div style="text-align: center; margin: 30px 0;">
          <p style="color: #637381; font-size: 14px; margin: 0; font-family: 'Segoe UI Regular';">${subtitle}</p>
        </div>
        
        ${
          pageNum === 0
            ? `
        <!-- Stats Cards - Only on first page -->
        <div style="display: flex; gap: 20px; margin: 30px 0;">
          <!-- Not Required Card -->
          <div style="flex: 1; background-color: #11B50C14; padding: 24px; border-radius: 8px; text-align: center; border: 1px solid #11B50C3D;">
            <div style="color: #11B50C; font-size: 36px; font-weight: bold; font-family: 'Segoe UI Bold';">${notRequired}</div>
            <div style="color: #16304F; font-size: 14px; font-family: 'segoe_uisemibold';">Not Required</div>
          </div>
          
          <!-- Inspection Card -->
          <div style="flex: 1; background-color: #E62B2A14; padding: 24px; border-radius: 8px; text-align: center; border: 1px solid #E62B2A3D">
            <div style="color: #E62B2A; font-size: 36px; font-weight: bold; font-family: 'Segoe UI Bold';">${inspection}</div>
            <div style="color: #16304F; font-size: 14px; font-family: 'segoe_uisemibold';">${fireSafety ? "Required" : "Inspection"}</div>
          </div>
 
          ${
            isRepairs
              ? `
          <div style="flex: 1; background-color: #FFA50014; padding: 24px; border-radius: 8px; text-align: center; border: 1px solid #FFA5003D">
            <div style="color: #FFA500; font-size: 36px; font-weight: bold; font-family: 'Segoe UI Bold';">${repair}</div>
            <div style="color: #16304F; font-size: 14px; font-family: 'segoe_uisemibold';">Repair</div>
          </div>
          `
              : ""
          }
        </div>
        `
            : ""
        }
        
        <!-- Page indicator -->
        <div style="text-align: right; margin-bottom: 10px;">
          <p style="color: #637381; font-size: 12px; font-family: 'Segoe UI Regular';">Page ${
            pageNum + 1
          } of ${totalPages}</p>
        </div>
        
        <!-- Table -->
        <table style="width: 100%; margin-top: 10px; border-collapse: collapse;">
          <thead>
            <tr>
              <th style="width: 5%; text-align: left; padding: 12px; font-family: 'segoe_uisemibold';">#</th>
              <th style="width: 50%; text-align: left; padding: 12px; font-family: 'segoe_uisemibold';">Building Address</th>
              <th style="width: 22%; text-align: left; padding: 12px; font-family: 'segoe_uisemibold';">Unit</th>
              <th style="width: 23%; text-align: left; padding: 12px; font-family: 'segoe_uisemibold';">${tableTitle}</th>
            </tr>
          </thead>
          <tbody>
            ${inspectionUnits
              .map(
                (unit, index) => `
               <tr>
                <td style="padding: 12px; font-family: 'Segoe UI Regular';">${
                  startIndex + index + 1
                }</td>
                <td style="padding: 12px; font-family: 'Segoe UI Regular';">${
                  unit.address
                }</td>
                <td style="padding: 12px;">
                  <div class="unit-badge" style="font-family: 'segoe_uisemibold';">${
                    unit.unit
                  }</div>
                </td>
                <td style="padding: 12px;">
                  <div class="inspection-badge" style="font-family: 'segoe_uisemibold';">${fireSafety ? "Required" : "Inspection"}</div>
                </td>
               </tr>
            `
              )
              .join("")}
          </tbody>
        </table>
      </div>
    `;
    
    // Add the div to the document
    document.body.appendChild(tempDiv);
    
    try {
      // Wait for fonts to load
      await document.fonts.ready;
      
      // Convert HTML to canvas
      const canvas = await html2canvas(tempDiv, {
        scale: 2, // Higher scale for better quality
        useCORS: true,
        logging: false,
        backgroundColor: "#ffffff",
        allowTaint: true,
        onclone: (clonedDoc) => {
          // This function is called with the cloned document
          // You can use it to ensure fonts are loaded in the clone
          const style = clonedDoc.createElement("style");
          style.innerHTML = fontFaces;
          clonedDoc.head.appendChild(style);
        },
      });
      
      // Add the canvas image to the PDF
      const imgData = canvas.toDataURL("image/png");
      doc.addImage(imgData, "PNG", 0, 0, 210, 297); // A4 size in mm
    } catch (error) {
      console.error("Error generating HTML to PDF:", error);
    } finally {
      // Clean up
      document.body.removeChild(tempDiv);
    }
  }
  
  // Handle case when there's no data
  if (buildingData.length === 0) {
    // Create a temporary div for empty state
    const tempDiv = document.createElement("div");
    tempDiv.style.position = "absolute";
    tempDiv.style.left = "-9999px";
    tempDiv.style.top = "-9999px";
    tempDiv.style.width = "794px"; // A4 width in pixels at 96 DPI
    
    tempDiv.innerHTML = `
      <style>
        ${fontFaces}
        * {
          box-sizing: border-box;
          margin: 0;
          padding: 0;
        }
      </style>
      <div style="width: 794px; height: 1123px; padding: 40px; font-family: 'Segoe UI Regular', sans-serif; position: relative; box-sizing: border-box; background-color: white;">
      <div style="display: flex; justify-content: center; align-items: center; margin-bottom: 30px;">
     <img src="${Logo}" style="width: 180px;">
     </div>
        <!-- Title -->
        <div style="text-align: center; margin-bottom: 30px;">
          <h1 style="color: #16304F; font-size: 32px; font-weight: bold; margin: 0; font-family: 'Segoe UI Bold'; text-transform: uppercase;">${title}</h1>
        </div>
        
        <!-- Horizontal line -->
        <div style="width: 100%; height: 1px; background-color: #EEEEEE; margin: 20px 0;"></div>
        
        <!-- Subtitle -->
        <div style="text-align: center; margin: 30px 0;">
          <p style="color: #637381; font-size: 14px; margin: 0; font-family: 'Segoe UI Regular';">${subtitle}</p>
        </div>
        
        <!-- Stats Cards -->
        <div style="display: flex; gap: 20px; margin: 30px 0;">
          <!-- Not Required Card -->
          <div style="flex: 1; background-color: #11B50C14; padding: 24px; border-radius: 8px; text-align: center; border: 1px solid #11B50C3D;">
            <div style="color: #11B50C; font-size: 36px; font-weight: bold; font-family: 'Segoe UI Bold';">${notRequired}</div>
            <div style="color: #16304F; font-size: 14px; font-family: 'segoe_uisemibold';">Not Required</div>
          </div>
          
          <!-- Inspection Card -->
          <div style="flex: 1; background-color: #E62B2A14; padding: 24px; border-radius: 8px; text-align: center; border: 1px solid #E62B2A3D">
            <div style="color: #E62B2A; font-size: 36px; font-weight: bold; font-family: 'Segoe UI Bold';">${inspection}</div>
            <div style="color: #16304F; font-size: 14px; font-family: 'segoe_uisemibold';">Inspection</div>
          </div>
 
          ${
            isRepairs
              ? `
          <div style="flex: 1; background-color: #FFA50014; padding: 24px; border-radius: 8px; text-align: center; border: 1px solid #FFA5003D">
            <div style="color: #FFA500; font-size: 36px; font-weight: bold; font-family: 'Segoe UI Bold';">${repair}</div>
            <div style="color: #16304F; font-size: 14px; font-family: 'segoe_uisemibold';">Repair</div>
          </div>
          `
              : ""
          }
        </div>
        
        <!-- Empty state message -->
        <div style="text-align: center; margin-top: 100px;">
          <p style="color: #637381; font-size: 16px; font-family: 'Segoe UI Regular';">No data available for this report.</p>
        </div>
      </div>
    `;
    
    document.body.appendChild(tempDiv);
    
    try {
      await document.fonts.ready;
      const canvas = await html2canvas(tempDiv, {
        scale: 2,
        useCORS: true,
        logging: false,
        backgroundColor: "#ffffff",
        allowTaint: true,
        onclone: (clonedDoc) => {
          const style = clonedDoc.createElement("style");
          style.innerHTML = fontFaces;
          clonedDoc.head.appendChild(style);
        },
      });
      
      const imgData = canvas.toDataURL("image/png");
      doc.addImage(imgData, "PNG", 0, 0, 210, 297);
    } catch (error) {
      console.error("Error generating empty HTML to PDF:", error);
    } finally {
      document.body.removeChild(tempDiv);
    }
  }
};

/**
 * Creates the building overview page from HTML
 * @param {jsPDF} doc - The PDF document
 * @param {Object} buildingData - Building data
 */
const createBuildingOverviewPageFromHTML = async (doc, pdfData,statusCount) => {
  // Calculate stats
  const totalUnits = pdfData.length;
  const windowGuardInstallations = statusCount.window_guard_installed_count; // Example fixed numbers to match image
  const windowGuardRepairs = statusCount.window_guard_need_repair_count;
  const visualInspections = statusCount.inspection_needed;
  const knobCoverInstallations = statusCount.knob_covers_required;
  const fireSafety = statusCount.fire_safety_required_count;
  const responses = statusCount.total - statusCount.pending; // From the image
  
  // Create a temporary div to hold our HTML
  const tempDiv = document.createElement('div');
  tempDiv.style.position = 'absolute';
  tempDiv.style.left = '-9999px';
  tempDiv.style.top = '-9999px';
  tempDiv.style.width = '794px'; // A4 width in pixels at 96 DPI
  
  // Create HTML content that exactly matches the image
  tempDiv.innerHTML = `
    <style>
      ${fontFaces}
      
      * {
        box-sizing: border-box;
        margin: 0;
        padding: 0;
      }
    </style>
    <div style="width: 794px; height: 1123px; padding: 20px; font-family: 'Inter', sans-serif; position: relative; box-sizing: border-box; background-color: white;">
      <div style="display: flex; justify-content: center; align-items: center; margin-bottom: 30px;">
     <img src="${Logo}" style="width: 180px;">
     </div>
      <!-- Title -->
      <div style="text-align: center; margin-top: 30px; ">
        <h1 style="color: #16304F; font-size: 32px; font-weight: bold; margin: 0; font-family: "Segoe UI Bold"; text-transform: uppercase;">BUILDING OVERVIEW</h1>
      </div>
      
      <!-- Horizontal line -->
      <div style="width: 100%; height: 1px; background-color: #EEEEEE; margin: 20px 0;"></div>
      
      <!-- Subtitle -->
      <div style="text-align: center; margin: 30px 0;">
        <p style="color: #637381; font-size: 14px; margin: 0;font-family: "Segoe UI Regular";">This report covers safety mailing data for 2025 for the following 1 properties:</p>
      </div>
      
      <!-- Building Address -->
      <div style="text-align: center; margin: 25px 0 40px; display: flex; justify-content: center; align-items: center;">
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" style="margin-right: 8px; vertical-align: middle;">
          <path d="M12 2.99905C10.1435 2.99905 8.36301 3.73654 7.05025 5.0493C5.7375 6.36205 5 8.14253 5 9.99905C5 12.861 6.782 15.622 8.738 17.761C9.73814 18.8507 10.8294 19.853 12 20.757C12.1747 20.623 12.3797 20.4597 12.615 20.267C13.5548 19.4953 14.4393 18.6586 15.262 17.763C17.218 15.622 19 12.862 19 9.99905C19 8.14253 18.2625 6.36205 16.9497 5.0493C15.637 3.73654 13.8565 2.99905 12 2.99905ZM12 23.213L11.433 22.823L11.43 22.821L11.424 22.816L11.404 22.802L11.329 22.749L11.059 22.552C9.69086 21.5238 8.41988 20.3723 7.262 19.112C5.218 16.874 3 13.635 3 9.99805C3 7.6111 3.94821 5.32191 5.63604 3.63409C7.32387 1.94626 9.61305 0.998047 12 0.998047C14.3869 0.998047 16.6761 1.94626 18.364 3.63409C20.0518 5.32191 21 7.6111 21 9.99805C21 13.635 18.782 16.875 16.738 19.11C15.5804 20.3703 14.3098 21.5218 12.942 22.55C12.8281 22.6352 12.713 22.7188 12.597 22.801L12.576 22.815L12.57 22.82L12.568 22.821L12 23.213ZM12 7.99905C11.4696 7.99905 10.9609 8.20976 10.5858 8.58483C10.2107 8.95991 10 9.46861 10 9.99905C10 10.5295 10.2107 11.0382 10.5858 11.4133C10.9609 11.7883 11.4696 11.999 12 11.999C12.5304 11.999 13.0391 11.7883 13.4142 11.4133C13.7893 11.0382 14 10.5295 14 9.99905C14 9.46861 13.7893 8.95991 13.4142 8.58483C13.0391 8.20976 12.5304 7.99905 12 7.99905ZM8 9.99905C8 8.93818 8.42143 7.92076 9.17157 7.17062C9.92172 6.42047 10.9391 5.99905 12 5.99905C13.0609 5.99905 14.0783 6.42047 14.8284 7.17062C15.5786 7.92076 16 8.93818 16 9.99905C16 11.0599 15.5786 12.0773 14.8284 12.8275C14.0783 13.5776 13.0609 13.999 12 13.999C10.9391 13.999 9.92172 13.5776 9.17157 12.8275C8.42143 12.0773 8 11.0599 8 9.99905Z" fill="#ED7047"/>
        </svg>
        <span style="color: #16304F; font-size: 20px; font-family: "segoe_uisemibold";">${
          pdfData[0]?.building_address || ""
        }</span>
      </div>
      
      <!-- Stats Grid -->
      <div style="display: flex; flex-wrap: wrap; justify-content: center; gap: 30px; padding: 0 20px; max-width: 100%; margin: 0 auto;">
        <!-- Row 1 -->
        <div style="display: flex; width: 100%; gap: 30px; justify-content: center;">
          <!-- Window Guard Installations -->
          <div style="width: 48%; height: 156px; background-color: #E62B2A14; border-radius: 16px; display: flex; flex-direction: column; align-items: center; justify-content: center;border: 1px solid #E62B2A3D;">
            <div style="color: #FF0000; font-size: 32px; font-weight: bold; line-height: 1;">${windowGuardInstallations}</div>
            <div style="color: #16304F; font-size: 12px; text-align: center; margin-top: 5px; line-height: 1.2; font-family: "segoe_uisemibold";">Window Guard<br>Installations</div>
          </div>
          
          <!-- Window Guard Repairs -->
          <div style="width: 48%; height: 156px; background-color: #FFA50014; border-radius: 16px; display: flex; flex-direction: column; align-items: center; justify-content: center;border: 1px solid #FFA5003D;">
            <div style="color: #FFA500; font-size: 32px; font-weight: bold; line-height: 1;">${windowGuardRepairs}</div>
            <div style="color: #16304F; font-size: 12px; text-align: center; margin-top: 5px; line-height: 1.2; font-family: "segoe_uisemibold";">Window Guard<br>Repairs</div>
          </div>
        </div>
        
        <!-- Row 2 -->
        <div style="display: flex; width: 100%; gap: 30px; justify-content: center;">
          <!-- Visual Inspections -->
          <div style="width: 48%; height: 156px; background-color: #ED704714; border-radius: 16px; display: flex; flex-direction: column; align-items: center; justify-content: center;border: 1px solid #ED70473D;">
            <div style="color: #FF6347; font-size: 32px; font-weight: bold; line-height: 1;">${visualInspections}</div>
            <div style="color: #16304F; font-size: 12px; text-align: center; margin-top: 5px; line-height: 1.2; font-family: "segoe_uisemibold";">Visual<br>Inspections</div>
          </div>
          
          <!-- Knob Cover Installations -->
          <div style="width: 48%; height: 156px; background-color: #EA3E2314; border-radius: 16px; display: flex; flex-direction: column; align-items: center; justify-content: center;border: 1px solid #EA3E233D;">
            <div style="color: #FF6347; font-size: 32px; font-weight: bold; line-height: 1;">${knobCoverInstallations}</div>
            <div style="color: #16304F; font-size: 12px; text-align: center; margin-top: 5px; line-height: 1.2; font-family: "segoe_uisemibold";">Knob Cover<br>Installations</div>
          </div>
        </div>

        <!-- Row 3 -->
        <div style="display: flex; width: 100%; gap: 30px; justify-content: center;">
          
          <!-- Fire Safety -->
          <div style="width: 48%; height: 156px; background-color: #EA3E2314; border-radius: 16px; display: flex; flex-direction: column; align-items: center; justify-content: center;border: 1px solid #EA3E233D;">
            <div style="color: #FF6347; font-size: 32px; font-weight: bold; line-height: 1;">${fireSafety}</div>
            <div style="color: #16304F; font-size: 12px; text-align: center; margin-top: 5px; line-height: 1.2; font-family: "segoe_uisemibold";">Fire Safety<br>Notice</div>
          </div>
        </div>
        
        <!-- Row 4 -->
        <div style="display: flex; width: 100%; gap: 30px; justify-content: center;">
          <!-- Total Units -->
          <div style="width: 48%; height: 156px; background-color: #355C9D14; border-radius: 16px; display: flex; flex-direction: column; align-items: center; justify-content: center;border: 1px solid #355C9D3D;">
            <div style="color: #4169E1; font-size: 32px; font-weight: bold; line-height: 1;">${totalUnits}</div>
            <div style="color: #16304F; font-size: 12px; text-align: center; margin-top: 5px; line-height: 1.2; font-family: "segoe_uisemibold";">Total Units</div>
          </div>
          
          <!-- Responses -->
          <div style="width: 48%; height: 156px; background-color: #11B50C14; border-radius: 16px; display: flex; flex-direction: column; align-items: center; justify-content: center;border: 1px solid #11B50C3D;">
            <div style="color: #32CD32; font-size: 32px; font-weight: bold; line-height: 1;">${responses}</div>
            <div style="color: #16304F; font-size: 12px; text-align: center; margin-top: 5px; line-height: 1.2; font-family: "segoe_uisemibold";">Responses</div>
          </div>
        </div>
      </div>
    </div>
  `;
  
  // Add the div to the document
  document.body.appendChild(tempDiv);
  
  try {
    // Wait for fonts to load
    await document.fonts.ready;
    
    // Convert HTML to canvas
    const canvas = await html2canvas(tempDiv, {
      scale: 2, // Higher scale for better quality
      useCORS: true,
      logging: false,
      backgroundColor: '#ffffff',
      allowTaint: true,
      onclone: (clonedDoc) => {
        // This function is called with the cloned document
        // You can use it to ensure fonts are loaded in the clone
        const style = clonedDoc.createElement('style');
        style.innerHTML = fontFaces;
        clonedDoc.head.appendChild(style);
      }
    });
    
    // Add the canvas image to the PDF
    const imgData = canvas.toDataURL('image/png');
    doc.addImage(imgData, 'PNG', 0, 0, 210, 297); // A4 size in mm
  } catch (error) {
    console.error('Error generating HTML to PDF:', error);
  } finally {
    // Clean up
    document.body.removeChild(tempDiv);
  }
};

/**
 * Downloads the generated PDF
 * @param {jsPDF} doc - The generated PDF document
 * @param {string} fileName - The file name for the PDF
 */
export const downloadPDF = (doc, fileName) => {
  doc.save(fileName);
}; 